/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ModelsFrequencyRange
 */
export interface ModelsFrequencyRange {
    /**
     * 
     * @type {number}
     * @memberof ModelsFrequencyRange
     */
    max?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelsFrequencyRange
     */
    min?: number;
    /**
     * "MHz" або "GHz"
     * @type {string}
     * @memberof ModelsFrequencyRange
     */
    unit?: string;
}

/**
 * Check if a given object implements the ModelsFrequencyRange interface.
 */
export function instanceOfModelsFrequencyRange(value: object): boolean {
    return true;
}

export function ModelsFrequencyRangeFromJSON(json: any): ModelsFrequencyRange {
    return ModelsFrequencyRangeFromJSONTyped(json, false);
}

export function ModelsFrequencyRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModelsFrequencyRange {
    if (json == null) {
        return json;
    }
    return {
        
        'max': json['max'] == null ? undefined : json['max'],
        'min': json['min'] == null ? undefined : json['min'],
        'unit': json['unit'] == null ? undefined : json['unit'],
    };
}

export function ModelsFrequencyRangeToJSON(value?: ModelsFrequencyRange | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'max': value['max'],
        'min': value['min'],
        'unit': value['unit'],
    };
}

